import React from "react";
import "../styles/BusinessHubNavigation.css";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "../icons/BusinessHub/SettingsIcon.js";
// import AnalaticPrefIcon from "../icons/BusinessHub/AnalaticPrefIcon.js";
import BusinessProfileIcon from "../icons/BusinessHub/BusinessProfileIcon.js";
import UserManageSelected from "../icons/BusinessHub/UserManageSelected.js";
// import AnalyticsIcon from "../icons/BusinessHub/AnalyticsIcon.js";
import BussinessReqIcon from "../icons/BusinessHub/BussinessReqIcon.js";
import ProductManagmentIcon from "../icons/BusinessHub/ProductManagmentIcon.js";
import { userService } from "../services/userService.js";
import Wallet from "../icons/Wallet.js";
import Utils from "../utils/Utils.js";
import PromotionAndMarketing from "../icons/PromotionAndMarketing.js";
import PaymentIcon from "../icons/PaymentIcon.js";
import OrderBoxIcon from "../icons/OrderBoxIcon.js";
import DeleveryManagementIcon from "../icons/DeleveryManagementIcon.js";
import { getRouteForActiveKey } from "../utils/businessHubRoutes.js";

function BusinessHubNavigation({ active, onSelect, mode, onItemClick }) {
  const jwt = userService.getUser();
  const parsed = Utils.parseJwt(jwt) || {};
  const isRoot = parsed?.isRoot === true;

  const navigate = useNavigate();
  const rowClass = (key) =>
    active === key
      ? "nevigation-selection-rows-selected"
      : "nevigation-selection-rows";
  const handleNavigate = (nextActive) => {
    const route = getRouteForActiveKey(nextActive);

    if (route) {
      navigate(route);
    } else if (mode) {
      navigate(getRouteForActiveKey("C"));
    } else {
      onSelect?.(nextActive);
    }

    onItemClick?.();
  };
  return (
    <div className="navigation-main-container">
      {mode ? (
        <div className="main-navigations">
          <div className="navigation-container-title">Main navigation</div>

          <div className="navigation-selection-section">
            <div className={rowClass("A")} onClick={() => handleNavigate("A")}>
              <div className="navigation-selection-icons">
                <BusinessProfileIcon
                  fill={active === "A" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">
                Business Overview
              </div>
            </div>

            {/**************************************************** */}
            {isRoot ? (
              <div
                className={rowClass("B")}
                onClick={() => handleNavigate("B")}
              >
                <div className="navigation-selection-icons">
                  <BussinessReqIcon
                    fill={active === "B" ? "#FFFFFF" : "#424242"}
                  />
                </div>
                <div className="navigation-selection-titles">
                  Business Requests
                </div>
              </div>
            ) : null}
            {/**************************************************** */}

            <div className={rowClass("C")} onClick={() => handleNavigate("C")}>
              <div className="navigation-selection-icons">
                <UserManageSelected
                  fill={active === "C" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">User Management</div>
            </div>

            <div className={rowClass("D")} onClick={() => handleNavigate("D")}>
              <div className="navigation-selection-icons">
                <ProductManagmentIcon
                  fill={active === "D" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">
                Product Management
              </div>
            </div>

            {/* <div className={rowClass("E")} onClick={() => handleNavigate("E")}>
              <div className="navigation-selection-icons">
                <AnalyticsIcon fill={active === "E" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="navigation-selection-titles">Analytics</div>
            </div> */}

            <div className={rowClass("H")} onClick={() => handleNavigate("H")}>
              <div className="navigation-selection-icons">
                <PromotionAndMarketing
                  stroke={active === "H" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">
                Promotions And Marketing
              </div>
            </div>

            <div className={rowClass("I")} onClick={() => handleNavigate("I")}>
              <div className="navigation-selection-icons">
                <PaymentIcon stroke={active === "I" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="navigation-selection-titles">Payment</div>
            </div>

            <div className={rowClass("M")} onClick={() => handleNavigate("M")}>
              <div className="navigation-selection-icons">
                <OrderBoxIcon stroke={active === "M" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="navigation-selection-titles">Order</div>
            </div>

            <div className={rowClass("L")} onClick={() => handleNavigate("L")}>
              <div className="navigation-selection-icons">
                <Wallet fill={active === "L" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="navigation-selection-titles">Wallet</div>
            </div>

            {/* <div className={rowClass("N")} onClick={() => handleNavigate("N")}>
              <div className="navigation-selection-icons">
                <DeleveryManagementIcon
                  stroke={active === "N" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">
                Delivery Management
              </div>
            </div> */}
          </div>
        </div>
      ) : (
        <div className="main-navigations">
          <div className="navigation-container-title">Main navigation</div>

          <div className="navigation-selection-section">
            <div className={rowClass("A")} onClick={() => handleNavigate("A")}>
              <div className="navigation-selection-icons">
                <BusinessProfileIcon
                  fill={active === "A" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">
                Business Overview
              </div>
            </div>

            {/**************************************************** */}
            {isRoot ? (
              <div
                className={rowClass("B")}
                onClick={() => handleNavigate("B")}
              >
                <div className="navigation-selection-icons">
                  <BussinessReqIcon
                    fill={active === "B" ? "#FFFFFF" : "#424242"}
                  />
                </div>
                <div className="navigation-selection-titles">
                  Business Requests
                </div>
              </div>
            ) : null}
            {/**************************************************** */}

            <div className={rowClass("C")} onClick={() => handleNavigate("C")}>
              <div className="navigation-selection-icons">
                <UserManageSelected
                  fill={active === "C" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">User Management</div>
            </div>

            <div className={rowClass("D")} onClick={() => handleNavigate("D")}>
              <div className="navigation-selection-icons">
                <ProductManagmentIcon
                  fill={active === "D" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">
                Product Management
              </div>
            </div>

            {/* <div className={rowClass("E")} onClick={() => handleNavigate("E")}>
              <div className="navigation-selection-icons">
                <AnalyticsIcon fill={active === "E" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="navigation-selection-titles">Analytics</div>
            </div> */}

            <div className={rowClass("H")} onClick={() => handleNavigate("H")}>
              <div className="navigation-selection-icons">
                <PromotionAndMarketing
                  stroke={active === "H" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">
                Promotions And Marketing
              </div>
            </div>

            <div className={rowClass("I")} onClick={() => handleNavigate("I")}>
              <div className="navigation-selection-icons">
                <PaymentIcon stroke={active === "I" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="navigation-selection-titles">Payment</div>
            </div>

            <div className={rowClass("M")} onClick={() => handleNavigate("M")}>
              <div className="navigation-selection-icons">
                <OrderBoxIcon stroke={active === "M" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="navigation-selection-titles">Order</div>
            </div>
            <div className={rowClass("L")} onClick={() => handleNavigate("L")}>
              <div className="navigation-selection-icons">
                <Wallet fill={active === "L" ? "#FFFFFF" : "#424242"} />{" "}
              </div>
              <div className="navigation-selection-titles">Wallet</div>
            </div>

            {/* <div className={rowClass("N")} onClick={() => handleNavigate("N")}>
              <div className="navigation-selection-icons">
                <DeleveryManagementIcon
                  stroke={active === "N" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="navigation-selection-titles">
                Delivery Management
              </div>
            </div> */}
          </div>
        </div>
      )}
      {mode ? (
        <div className="navigation-settings-container">
          <div className="settings-container-title">Settings</div>
          <div className="settings-container-section">
            <div className={rowClass("F")} onClick={() => handleNavigate("F")}>
              <div className="settings-row-icon ">
                <SettingsIcon fill={active === "F" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="settings-container-row-title">
                Company Settings
              </div>
            </div>
            {/* <div className={rowClass("G")} onClick={() => handleNavigate("G")}>
              <div className="settings-row-icon ">
                <AnalaticPrefIcon
                  fill={active === "G" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="settings-container-row-title">
                Analytics Preferences
              </div>
            </div> */}
          </div>
        </div>
      ) : (
        <div className="navigation-settings-container">
          <div className="settings-container-title">Settings</div>
          <div className="settings-container-section">
            <div className={rowClass("F")} onClick={() => handleNavigate("F")}>
              <div className="settings-row-icon ">
                <SettingsIcon fill={active === "F" ? "#FFFFFF" : "#424242"} />
              </div>
              <div className="settings-container-row-title">
                Company Settings
              </div>
            </div>
            {/* <div className={rowClass("G")} onClick={() => handleNavigate("G")}>
              <div className="settings-row-icon ">
                <AnalaticPrefIcon
                  fill={active === "G" ? "#FFFFFF" : "#424242"}
                />
              </div>
              <div className="settings-container-row-title">
                Analytics Preferences
              </div>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
}

export default BusinessHubNavigation;
